export default __webpack_public_path__ + "static/media/test-download.46224943.svg";